import {Component} from '@angular/core';
import {ITooltipAngularComp} from 'ag-grid-angular';

@Component({
    selector: 'tooltip-component',
    template: `
        <div class="custom-tooltip">
            <p>{{ valueToDisplay }}</p>
        </div>
    `,
    styles: [
        `
            :host {
                position: absolute;
                width: 165px;
                height: 80px;
                border: 1px solid cornflowerblue;
                overflow: hidden;
                pointer-events: none;
                transition: opacity 1s;
            }

            :host.ag-tooltip-hiding {
                opacity: 0;
            }

            .custom-tooltip p {
                margin: 5px;
                white-space: nowrap;
            }

            .custom-tooltip p:first-of-type {
                font-weight: bold;
            }
        `,
    ],
})
export class CustomTooltipComponent implements ITooltipAngularComp {

    public valueToDisplay: string;

    public agInit(params): void {
        this.valueToDisplay = params.value.value;
    }
}
